var stickyBtnsBlock = $('#sticky-banking-btns'),
    makeBankingBeautyBtns;
(function($) {
	$(function() {
		if (stickyBtnsBlock.length) {
			var mcaCol = $('#mca-col'),
			    scaCol = $('#sca-col'),
			    //btnsLeftPosTo = (rtl) ? scaCol : mcaCol,
			    mcaBtn = stickyBtnsBlock.find('.mca'),
			    btnsHeight,
			    dccChatDocket;
			var checkForDcChat = setInterval(function() {
				if ($('.dccChatDocket').length) {
					dccChatDocket = $('.dccChatDocket').addClass('animated');
					clearInterval(checkForDcChat);
				}
			}, 500)
			makeBankingBeautyBtns = function() {
				destroyBankingBeautyBtns();

				if (winWidth >= cssBreakPoints.md) {
					var showBtnsScroll = $('#show-btns-level').offset().top,
					    finishBtnsScroll = stickyBtnsBlock.offset().top,
					    btnsleftPos = stickyBtnsBlock.offset().left,
					    mcaColWidth = mcaCol.outerWidth(),
					    stickyBtnsBlockWidth = mcaColWidth + scaCol.outerWidth();
					stickyBtnsBlock.width(stickyBtnsBlockWidth);
					mcaBtn.outerWidth(mcaColWidth);
					btnsHeight = stickyBtnsBlock.outerHeight();
					stickyBtnsBlock.css('left', stickyBtnsBlock.offset().left);
					//stickyBtnsBlock.css('right', winWidth - stickyBtnsBlock.offset().left - stickyBtnsBlockWidth);
					var winScroll,
					    prevWinScroll;
					stickyBtnsBlock.parent().height(btnsHeight);

					$window.on('scroll.sticky-banking-btns', function() {
						winScroll = $window.scrollTop();

						if (winScroll + winHeight > showBtnsScroll) {

							if (winScroll + winHeight < finishBtnsScroll + btnsHeight) {

								if (winScroll - prevWinScroll < 0) {//if scroll to top

									if (winScroll + winHeight < finishBtnsScroll) {
										showBankingBeautyBtns();
									}

								} else {
									showBankingBeautyBtns();
								}

								hideDcChat();
							} else {
								staticBankingBeautyBtns();

								if (dccChatDocket && (winScroll + winHeight > finishBtnsScroll + btnsHeight + dccChatDocket.height())) {
									showDcChat();
								} else {
									hideDcChat();
								}

							}

						} else {
							stickyBtnsBlock.removeClass('shown').css('margin-top', 0);
							showDcChat();
						}
						prevWinScroll = winScroll;
					});
				}
			}
			makeBankingBeautyBtns();
			function showBankingBeautyBtns() {
				if (!stickyBtnsBlock.hasClass('shown')) {
					stickyBtnsBlock.addClass('fixed shown').css('margin-top', -btnsHeight);
				}
			}
			function staticBankingBeautyBtns() {
				stickyBtnsBlock.removeClass('fixed shown').css('margin-top', 0);
			}
			function destroyBankingBeautyBtns() {
				stickyBtnsBlock.removeClass('fixed shown').css('margin-top', 0);
				stickyBtnsBlock.width('auto');
				mcaBtn.outerWidth('auto');
				stickyBtnsBlock.parent().height('auto');
			}
			function hideDcChat() {

				if (dccChatDocket && !dccChatDocket.hasClass('hidd')) {
					dccChatDocket.addClass('hidd');
				}

			}
			function showDcChat() {

				if (dccChatDocket && dccChatDocket.hasClass('hidd')) {
					dccChatDocket.removeClass('hidd');
				}

			}
		}
	});
})(jQuery);